enum Paths {
  BASE = '',
  MAIN = BASE + '/main',
}

export default Paths;
